import type { DetailContentInfo } from '__generated__/api/unauth';
import { cn } from '@core/utils';

import { MayDeliveryNoticeImage } from '@/app/_components/MayDeliveryNoticeImage';

import { TABS } from '../../../../constants';
import { GiftDetailBannerAd } from '../../../GiftDetailBannerAd';
import { Contents } from './_components/Contents';
import { Notice } from './_components/Notice';
import { StaticBanner } from './_components/StaticBanner';

interface GiftTabContentBasicProps {
  detailContentInfoList: DetailContentInfo[];
  noticeContents?: string;
  noticeTitle?: string;
  productName?: string;
}

export const GiftTabContentBasic = ({
  detailContentInfoList,
  noticeContents,
  noticeTitle,
  productName,
}: GiftTabContentBasicProps) => {
  return (
    <section
      id={TABS.BASIC}
      className={cn(
        'flex flex-col border-1 border-Gray-300',
        'mobile-tablet:border-0',
      )}
    >
      {noticeTitle && noticeContents ? (
        <Notice
          content={noticeContents}
          productName={productName}
          title={noticeTitle}
        />
      ) : null}
      <StaticBanner />
      <MayDeliveryNoticeImage />
      <Contents detailContentInfoList={detailContentInfoList} />
      <GiftDetailBannerAd />
    </section>
  );
};
